import React from "react";
import { useInView } from "react-intersection-observer";

const Tokenomics = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // Only trigger once when the element comes into view
  });

  return (
    <>
      <section
        id="tokenomics"
        ref={ref}
        // style={{backgroundColor:'#100f19'}}
        className={`Tokenomics Introducing ${inView ? "showcontent" : ""}`}
      >
        {/* <div className="token">
          <img className="w-100" src="/images/TOKEN.png" alt="tokonomics" />
          <img className="  swap" src="/images/swap.svg" alt="swap" />
        </div> */}
        <div className="container">
          <div className="row align-items-center">
            <div className="text-center mb-3">
              <h2>Tokenomics</h2>
            </div>
            <div className="text-center mb-5">
              <p>A Token Designed to Reward Participation</p>
            </div>
            <div className="col-12">
              <div className="content">
                <div className="left-content">
                  <div className="txt"></div>
                  <ul className="list-inline">
                    <li className="">
                      <div>
                        <h3>Presale</h3>
                        <label>10%</label>
                      </div>
                      <div>
                        <h4>500</h4>
                        <h5>Million</h5>
                      </div>
                    </li>
                    <li className="">
                      <div>
                        <h3>Team</h3>
                        <label>10%</label>
                      </div>
                      <div>
                        <h4>500</h4>
                        <h5>Million</h5>
                      </div>
                    </li>
                    <li className="">
                      <div>
                        <h3>Validators</h3>
                        <label>40%</label>
                      </div>
                      <div>
                        <h4>2</h4>
                        <h5>billion</h5>
                      </div>
                    </li>
                    <li className="">
                      <div>
                        <h3>Bakers</h3>
                        <label>40%</label>
                      </div>
                      <div>
                        <h4>2</h4>
                        <h5>Billion</h5>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="right-content">
                  <div className="circle-content">
                    <img src="/images/graphcircle.png" />
                    <div className="one">
                      <span>40%</span>
                      Validators
                    </div>
                    <div className="two">
                      <span>10%</span>
                      Team
                    </div>
                    <div className="three">
                      <span>10%</span>
                      Presale
                    </div>
                    <div className="four">
                      <span>40%</span>
                      Bakers
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="token-graph mt-5">
            <img src="/images/token-graph.png" alt="" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Tokenomics;
